import React from 'react'

import { Dropdown, useModalContext } from '@sketch/components'
import {
  MoveStorageItemModal,
  MoveStorageItemModalAction,
} from '../../../storageItems'
import type { ShareForShareDropdown } from './ShareActionsDropdown'

interface MoveShareActionProps {
  share: ShareForShareDropdown
  workspaceIdentifier: string
  label: string
  action: MoveStorageItemModalAction
}

export const MoveShareAction = (props: MoveShareActionProps) => {
  const { share, workspaceIdentifier, label, action } = props
  const { showModal } = useModalContext()

  return (
    <Dropdown.Item
      onClick={() =>
        showModal(MoveStorageItemModal, {
          item: share,
          workspaceIdentifier,
          parentProjectIdentifier: share.project?.identifier || null,
          action,
          originType:
            share.archivedAt || share.deletedAt ? 'stashed' : 'standard',
        })
      }
    >
      {label}
    </Dropdown.Item>
  )
}
